.errorContainer {
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  background-color: $ui-black;
  color: $ui-white;
}

.error {
  color: $error-red;
}

.report {
  color: $blue-500;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  &:hover {
    color: $ontime-color;
  }
}
